export default __webpack_public_path__ + "static/media/347.c3a153fd.png";